/**
 * Contexto de autenticacion contra el SSO.
 */

import { createContext } from 'react';
import type { AuthSession } from '@domain/services';

export interface AuthContextType {
  session: AuthSession | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  /** Redirige a la pantalla unica de login del SSO. */
  login: () => Promise<void>;
  /** Procesa el retorno del proveedor tras el login. */
  completeLogin: () => Promise<void>;
  logout: () => Promise<void>;
  hasRole: (...roles: string[]) => boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
